// Route constants for type-safe navigation
export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  USERS: '/users',
  USERS_CLIENTS: '/users/clients',
  USERS_THERAPISTS: '/users/therapists',
  PROTOCOLS: '/protocols',
  QUESTIONNAIRES: '/questionnaires',
  FEATURES: '/features',
  SUPPORT: '/support',
  CHAT: '/chat',
  DASHBOARDS: '/dashboards',
  COMPANIES: '/companies',
  PLANS: '/plans',
  FAQ: '/faq',
  SPECIALIZATIONS: '/specializations',
  ACTION_REPORT: '/action-report',
} as const;

// Type for route values
export type RouteValue = typeof ROUTES[keyof typeof ROUTES];

// Helper function for type-safe navigation
export const navigateTo = (navigate: (path: string) => void, route: RouteValue) => {
  navigate(route);
};